<template>
  <div>
    <v-flex md6>
      <v-alert
        :value="alert"
        type="info"
        color="info"
        transition="scale-transition"
      >
        <v-spacer></v-spacer>
        <v-layout align-center wrap>
          <div>Contratos Masivos</div>
          <v-spacer></v-spacer>
          <div>Cantidad:{{ count }}</div>
          <v-btn
            :loading="loading"
            color="info"
            @click="callToContratacionMultiple()"
          >
            Contratar
          </v-btn>
        </v-layout>
        <div class="text-xs-center"></div>
      </v-alert>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: {
    count: "",
  },
  data() {
    return {
      loading: false,
      alert: true,
    };
  },
  methods: {
    callToContratacionMultiple() {
      this.$parent.multipleContratacion();
      this.loading = true;
      this.$parent.reload();
      this.loading = false;
    },
  },
};
</script>
